export default "__VITE_ASSET__hynajxDd__"